$(document).ready(function(){
  initPage();
});

function initPage(){
  //gallery('[data-gallery]');
  quantitySelector();
  nouisliders();
  productCard();
  multiproduct();
  forms();
  popups();
  addressForm();
  szoom();
  addCart();
  invoices();
  giftCard();
  zoomGallery();
  recentlyViewed();
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}

function addressForm(){
  $('.address-form').each(function(){
    address(this);
  });

  function address(form){
    var province = $(form).find('[data-province-select]');
    var country = $(form).find('[data-country-select]');
    setProvince();

    $(country).on('change', setProvince);
    function setProvince(){
      try {
        var provinces = JSON.parse($(country).find('option:selected').attr('data-provinces'));
        if(provinces.length){
          var p = ['<option value=""></option>'];
          $(provinces).each(function(){
            p.push('<option value="'+this[0]+'">'+this[0]+'</option>');
          });
          $(province).html(p.join(''));
        } else {
          $(province).html("");
        }
      } catch{
        $(province).html("");
      }
    }
  }
}

function gallery(el){
  $(el).each(function(){
    var initial = parseInt($(this).attr('data-gallery-initial'));
    var thumbs = $(this).find('[data-gallery-thumbs]');
    var main = $(this).find('[data-gallery-main]');

    var swiper = new Swiper($(thumbs).get(0), {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      initialSlide: initial,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        992: {
          direction: 'vertical'
        }
      }
    });
    
    var swiper2 = new Swiper($(main).get(0), {
      spaceBetween: 10,
      zoom: true,
      loop: true,
      initialSlide: initial,
      thumbs: {
        swiper: swiper,
      },
    });
  });
}

function zoomGallery(){
  var done = false;
  $('#zoom').on('shown.bs.modal', function(){
    if(done == false){
      //gallery('[data-gallery-zoom]');
      done = true;
    }
  });
}

function quantitySelector(){
  $('[data-quantity-selector]').each(function(){
    qSelector(this);
  });

  function qSelector(el){
    var input = $(el).find('[data-quantity-input]');
    var minus = $(el).find('[data-quantity-minus]');
    var plus = $(el).find('[data-quantity-plus]');
    var sub = $(el).find('[data-quantity-submit]').length > 0;

    $(input).on('blur', function(){
      setValue($(this).val());
    });
    
    $(minus).on('click', function(){
      setValue($(input).val(), -1);
    });
    
    $(plus).on('click', function(){
      setValue($(input).val(), 1);
    });

    function setValue(str, add=0){
      try{
        var val = parseInt(str);
        if(!val || val <= 0 || val == NaN){
          $(input).val(1);
        } else {
          if(add != 0)
            val = val + add;
          if(val > 0)
            $(input).val(val);
        }
      } catch(e){
        $(input).val(1);
      }
      if(sub){
        $(el).parents('form').trigger('submit');
      }
    }
  }
}

function nouisliders(){
  $('[data-uislider]').each(function(){
    var min = Number($(this).attr('data-uislider-from'));
    var max = Number($(this).attr('data-uislider-to'));
    var start = Number($(this).attr('data-uislider-min'));
    var end = Number($(this).attr('data-uislider-max'));
    var symbol = $(this).attr('data-uislider-symbol');
    var minparam = $(this).attr('data-uislider-minparam');
    var maxparam = $(this).attr('data-uislider-maxparam');

    var parent = $(this).parents('[data-uislider-parent]');
    var minvalue = $(parent).find('[data-uislider-minvalue]');
    var maxvalue = $(parent).find('[data-uislider-maxvalue]');

    var url = new URL(location.href);
    
    if(this.noUiSlider == undefined){
      var slider = noUiSlider.create(this, {
        start: [start, end],
        connect: true,
        'step': 500,
        range: {
          'min': min,
          'max': max
        }
      }, true);
      slider.on('update', function(values){
        $(minvalue).text(symbol+(values[0]/100).toFixed(2));
        $(maxvalue).text(symbol+(values[1]/100).toFixed(2));
      });
      if(minparam != undefined && maxparam != undefined){
        slider.on('change', function(values){
          if(values[0] != start)
            url.searchParams.set(minparam, values[0]/100);
          if(values[1] != end)
            url.searchParams.set(maxparam, values[1]/100);
          if(values[0] != start || values[1] != end){
            location.href = url;
          }
        });
      }
    }
  });
}

function recentlyViewed(){
  $('[data-viewed]').each(function(){
    var container = this;
    var id = $(container).attr('data-viewed');
    var product = $('[data-viewed-product="'+id+'"]').text();
    var compare = $('[data-viewed-compare="'+id+'"]').text();

    var products = '';
    var index = 0;

    var items = JSON.parse(localStorage.getItem('viewed'));
    if(items != null && items.length > 0){
      appendProduct({
        items: items,
        index: index,
        products: products,
        container: container,
        product: product,
        compare: compare
      });
    }
  });

  function setTemplate(products, container){
    var id = $(container).attr('data-viewed');
    var template = $('[data-viewed-template="'+id+'"]').text();

    template = template.replaceAll('{products}', products);
    $(container).html(template);
  }

  function appendProduct(obj){
    $.getJSON(window.Shopify.routes.root + 'products/'+obj.items[obj.index]+'.js', function(p) {
      var pTemp = obj.product.replaceAll('{title}', p.title)
                  .replaceAll('{image}', p.featured_image)
                  .replaceAll('{url}', p.url)
                  .replaceAll('{price}', formatMoney(p.price));
      if(p.price < p.compare_at_price){
        var pComp = obj.compare.replaceAll('{compare}', formatMoney(p.compare_at_price))
                                .replaceAll('{percentage}', parseInt((p.compare_at_price-p.price)/p.compare_at_price*100));
        pTemp = pTemp.replaceAll('{compare}', pComp);
      } else {
        pTemp = pTemp.replaceAll('{compare}', '');
      }
      obj.products = pTemp + obj.products;
      obj.index++;
      if(obj.index < obj.items.length){
        appendProduct(obj);
      } else {
        setTemplate(obj.products, obj.container);
      }
    });        
  }
}

function formatMoney(price){
  const p = ((price/100).toFixed(2)).replaceAll('.', ',');
  var f = '<font class="font-price">€ '+p+'</font>';
  if(currency_format != undefined){
    f = currency_format.replaceAll('{{amount_with_comma_separator}}', p);
  }
  return f;
}

window.saveViewed = function(handle){
  var items = JSON.parse(localStorage.getItem('viewed'));
  if(!items){
    items = [];
    items.push(handle);
  } else {
    var found = false;
    $(items).each(function(){
      if(this.localeCompare(handle) === 0){
        found = true;
        return false;
      }
    });
    if(!found){
      items.push(handle);
      if(items.length > 6){
        items.shift();
      }
    }
  }
  localStorage.setItem('viewed', JSON.stringify(items));
}

function productCard(){
  var classname = 'border';
  $('[data-card-variant]').on('click', function(){
    var thumb = $(this).attr('data-card-variant');
    var card = $(this).parents('[data-card]');
    var image = $(card).find('[data-card-image] img');
    $(image).attr('src', thumb);
    $(image).attr('srcset', thumb);
    $(card).find('[data-card-variant]').removeClass(classname);
    $(this).addClass(classname);
  });

  $('[data-variants-toggle]').on('click', function(){
    var parent = $(this).parents('[data-variants-parent]');
    var thumbs = $(parent).find('[data-variants-element]');
    $(thumbs).removeClass('d-none').removeClass('d-sm-none').removeClass('d-lg-none').removeClass('d-xl-none');
    $(this).remove();
  });
}

function dispatchBIS(url) {
  var sParam = 'variant';
  var variantId;
  var sURLVariables = url.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      variantId = typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  if (!variantId) return;
  var event = new CustomEvent('OrdersifyFormChange', { detail: { variantID: variantId } })
  document.body.dispatchEvent(event)
}

function multiproduct(){
  $('[data-multiproduct-variants]').on('change', function(){
    var parent = $(this).parents('[data-multiproduct]');
    var checkbox = $(parent).find('[data-multiproduct-checkbox]');
    $(checkbox).val($(this).val());
  });

  $('[data-multiproduct-checkbox]').on('change', function(){
    var price = 0;
    $('[data-multiproduct-checkbox]:checked').each(function(){
      price = parseInt($(this).attr('data-multiproduct-checkbox')) + price;
    });
    $('[data-multiproduct-total]').html(formatMoney(price));
  });
}

function popups(){
  $('[data-popup-now]').each(function(){
    var id = $(this).attr('id');
    var modal = new bootstrap.Modal(document.getElementById(id), {});
    modal.show();
  });
  $('[data-popup-delay]').each(function(){
    var delay = parseInt($(this).attr('data-popup-delay'))*1000;
    var id = $(this).attr('id');
    var modal = new bootstrap.Modal(document.getElementById(id), {});
    setTimeout(function(){
      modal.show();
    }, delay);
  });
  $('[data-popup-scroll]').each(function(){
    var percentage = parseInt($(this).attr('data-popup-scroll'));
    var id = $(this).attr('id');
    var modal = new bootstrap.Modal(document.getElementById(id), {});
    $(window).on('scroll', function(){
      if(getScrollPercent() >= percentage){
        modal.show();
        $(window).off('scroll');
      }
    })
  });
}

function forms(){
  $.extend($.validator.messages, form_errors);
  $('[data-validate]').each(function(){
    $(this).validate({
      highlight: function(element) {
          $(element).parents('.form-group').addClass("was-validated");
      },
      unhighlight: function(element) {
          $(element).parents('.form-group').removeClass("was-validated");
      },
      errorPlacement: function(error, element) {
        var placement = $(element).parents('.form-group').find('.invalid-feedback');
        $(placement).append(error);
      }
    });
  });

  $('[data-form-submit]').on('click', function(){
    var form = $(this).parents('form');
    Swal.fire({
      "icon": "info",
      "title": "Wait...",
      showCancelButton: false,
      showConfirmButton: false
    });
    $.ajax({
      type: $(form).attr('method'),
      url: $(form).attr('action'),
      data: new FormData($(form).get(0)),
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        location.reload();
      },
      error: function (err) {
        console.log(err);
        Swal.fire({
          "icon": "error",
          "title": "There was an error", 
          "text": "Please retry"
        });
      }
    });
  });

  $('[data-validate-submit]').on('click', function(){
    var form = $(this).parents('form');
    if($(form).length && $(form).valid()){
      $(form).trigger('submit');
    }
  });
}

function szoom(){
  $('[data-zoom]').each(function(){
    $(this).zoom({ on:'toggle' });	
  });
}

function addCart(){
  $('[data-add-cart]').on('click', function(){
    var form = $(this).parents('form').get(0);
    var params = new FormData(form);
    $.ajax({
      type: 'POST',
      url: $(form).attr('action'),
      data: params,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        $(window).trigger('theme-cart-add', data);
        location.href = window.Shopify.routes.root+'cart';
      },
      error: function (err) {
        console.log(err);
      }
    });
  });
}


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          productCard();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.get('product-recommendations') || customElements.define('product-recommendations', ProductRecommendations);


function invoices(){
  $('[data-invoice-request]').off().on('change', function(){
    $('[data-invoice-checkbox]').prop('checked', $(this).is(':checked'));
  });

  $('#modal-invoice [data-form-submit]').off().on('click', function(){
    var form = $(this).parents('form');
    if($(form).valid()){
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: new FormData($(form).get(0)),
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          location.reload();
        },
        error: function (err) {
          console.log(err);
        }
      });
    }
  });

  $('[data-invoice-remove]').off().on('click', function(){
    var data = new FormData();
    data.append('attributes[invoice]', 0);
    data.append('attributes[invoice_company]', null);
    data.append('attributes[invoice_vat]', null);
    data.append('attributes[invoice_address]', null);
    data.append('attributes[invocie_pec]', null);
    data.append('attributes[invoice_type]', null);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        location.reload();
      },
      error: function (err) {
        console.log(err);
      }
    });
  });
}

function giftCard(){
  if($('#qr-code').length){
    var code = $('#qr-code').attr('data-identifier');
    new QRCode( document.querySelector('#qr-code'), {
      text: code,
      width: 150,
      height: 150,
      imageAltText: 'qr'
    });
  }

  $('[data-copy]').on('click', function(){
    navigator.clipboard.writeText($(this).attr('data-copy'));
    var feed = $(this).attr('data-copy-element');
    var copied = $(this).attr('data-copy-text');
    var text = $(feed).text();
    
    $(feed).text(copied);
    setTimeout(function(){
      $(feed).text(text);
    }, 4000);
  });
}